import Page from "@/Pages/Page";
import React from "react";
import Quote from "@/Molecules/Quote/Quote";
import imageBackgroundField from "@images/media/blurry-field.png";
import imageIpad from "@images/media/ipad.png";
import {relativeRoute} from "@/helpers/relativeRoute";
import imageOnlineRouwbericht1 from "@images/media/herdenkingspagina2.png";
import imageOnlineRouwbericht2 from "@images/media/herdenkingspagina-mobile.png";
import imageOnlineRouwbericht3 from "@images/media/online-rouwbericht/online-rouwbericht-3.png";
import imageOnlineRouwbericht4 from "@images/media/online-rouwbericht/online-rouwbericht-4.png";
import SectionHeader from "@/Organisms/SectionHeader/SectionHeader";
import {useApp} from "@/Providers/AppProvider";
import CallToAction from "@/Molecules/CallToAction/CallToAction";

export default function OnlineRouwbericht() {

  const {onboarding} = useApp()

  return <Page title={'Online rouwbericht'}>

    <SectionHeader
      beige
      image={imageOnlineRouwbericht1}
      title={'Uitgebreide rouwpagina'}
      content={<>
      <p>Een uitgebreide rouwpagina (voorheen ‘herdenkingspagina’) is de digitale variant van een rouwadvertentie (hoofdadvertentie) in de krant en is met de extra functionaliteiten een upgrade van de standaard rouwpagina. </p>
      <p>De uitgebreide herdenkingspagina biedt een moderne, flexibele en kostenefficiënte manier om een overlijden bekend te maken en te herdenken, met tal van voordelen voor de gebruikers (zowel nabestaanden als uitvaartondernemers).</p>
      </>}
    />

    <section >
      <div className="container text-left">
        <div className={'sm:px-8'}>
          <h2>Upgrade van de standaard rouwpagina</h2>
          <p>De uitgebreide rouwpagina is een upgrade van de standaard rouwpagina. Deze uitgebreide herdenkingspagina
            biedt meer functionaliteiten en personalisatie-mogelijkheden en kun je op gewenst moment uitbreiden met:</p>
          <ul className={'small'}>
            <li>Praktische informatie over de condoleance en/of uitvaart</li>
            <li>Een passende omslag- en profielfoto</li>
            <li>Het levensverhaal en levensgebeurtenissen</li>
            <li>Dierbare foto’s</li>
          </ul>
        </div>
      </div>

    </section>


    <section>
      <div className="container cta cta-reverse">
        <div className={' bg-beigedark'}>
          <div className={'p-10'}>
            <h2 className={'mb-5'}>Voordelen uitgebreide rouwpagina:</h2>
            <ul className={'list'}>
              <li><strong>Sneller online</strong>: De pagina kan op ieder gewenst moment live worden gezet, ook als het drukwerk nog niet gereed is. Dit biedt een snellere en flexibelere oplossing in vergelijking met een traditionele printadvertentie.
              </li>
              <li><strong>Groter bereik</strong>: Het overlijden kan sneller en efficiënter bekendgemaakt worden aan een breder publiek, wat ideaal is voor kennissen, vrienden en familie die niet in dezelfde regio wonen.
              </li>
              <li><strong>Eenvoudig deelbaar</strong>: De pagina is te delen via verschillende kanalen, zoals mail, Facebook en WhatsApp.</li>
              <li><strong>Condoleances ontvangen</strong>: Nabestaanden kunnen condoleances direct op de rouwpagina achterlaten/ontvangen, wat een troostende en verbindende ervaring biedt, zelfs tot ver na de uitvaart.</li>
              <li><strong>QR-code en deelbare link aanmaken</strong>: Maak het overlijden bekend, nog voordat het drukwerk gereed is en voeg de QR-code of URL toe aan de rouwkaart en/of zet de QR-code in tijdens de uitvaart, zodat alle condoleances op één centrale plek terechtkomen.</li>
              <li><strong>Kostenbesparend</strong>: Een uitgebreide rouwpagina is een kostenbesparende manier om een overlijden bekend te maken.</li>
              <li><strong>Personaliseer</strong>: Voeg informatie toe over de uitvaart en breid de pagina uit met een omslag- en profielfoto, levensgebeurtenissen, het levensverhaal en dierbare foto's.</li>
              <li><strong>Accountbeheer: </strong>Voeg meerdere beheerders toe aan de pagina en heb de volledige controle over de ontvangen online condoleances (bijvoorbeeld in privémodus zetten).</li>
              <li><strong>Reclame-vrij: </strong>Op de uitgebreide rouwpagina worden geen reclames getoond.</li>
            </ul>
          </div>
          <img src={imageOnlineRouwbericht2} alt=""/>
        </div>

      </div>
    </section>


    <section  className={'bg-beige'}>
      <div className="container cta">
        <div>
          <div>
            <h2 className={'mb-5'}>Voordelen voor de uitvaartondernemer</h2>
            <ul className={'list'}>
              <li><strong>Uitbreiding van het dienstenaanbod</strong>: De uitgebreide rouwpagina is een mooie, digitale toevoeging op de bestaande (print) producten, waarmee de uitvaartondernemer moderne oplossingen biedt aan de families.</li>
              <li><strong>Veelzijdig inzetbaar</strong>: De uitgebreide rouwpagina is breed inzetbaar, bijvoorbeeld als aanvulling op de rouwkaart en als online condoleanceregister.</li>
              <li><strong>Zichtbaar in het online condoleanceregister</strong>: Heb jij het <a
                href={relativeRoute('online-condoleanceregister')}>gratis
                online condoleanceregister</a> van Mensenlinq op jouw website, dan zijn de uitgebreide rouwpagina's van uitvaarten die jij hebt begeleid, automatisch zichtbaar op jouw website.</li>
            </ul>
          </div>
          <img src={imageOnlineRouwbericht3} alt=""/>
        </div>
      </div>
    </section>


    <section className="section-a !pb-10 ">
      <div className="container">
        <div className={'intro'}>
          <h2>Start de bekendmaking met het aanmaken van een QR-code of URL</h2>
          <p>Iedereen bereiken die je wilt bereiken? Start het bekendmaken van een overlijden op Mensenlinq, door een uitgebreide rouwpagina aan te maken en een QR-code of URL naar de gepersonaliseerde pagina te generen. </p>
          <p><strong>Dit is al mogelijk vóórdat er een printadvertentie of rouwkaart is.</strong></p>
        </div>
        <div className="tripple">
          <div>
            <h4>Één centraal informatiepunt, deelbaar via alle kanalen.</h4>
            <p>Creëer één centrale plek waar men informatie over de condoleance en uitvaart kan vinden, waar men online condoleances kan ontvangen/achterlaten en waar de overleden dierbare wordt herinnerd.<br />

              <a href={relativeRoute('uitgebreide-rouwpagina-voorbeeld')}>Bekijk hier een voorbeeld van de uitgebreide rouwpagina</a>.
            </p>
          </div>

          <div>
            <img src={imageOnlineRouwbericht4} alt=""/>
          </div>

          <div>
            <h4>QR-code toepassingen:</h4>
            <p>In de printadvertentie, op de rouwkaart en tijdens de uitvaart.</p>

            <h4>URL toepassingen:</h4>
            <p>Deelbaar via verschillende online kanalen. </p>
          </div>


        </div>
      </div>
    </section>


    <Quote
      content={"Door de uitgebreide rouwpagina konden we het overlijden van mijn man snel bekendmaken. We voegden informatie toe over de uitvaart en deelden de link met iedereen die we wilden informeren. Zo wisten we zeker dat iedereen op tijd op de hoogte was van de uitvaartdatum en -locatie. Mijn zoon breidde de pagina uit met mooie foto's en het levensverhaal. Veel mensen namen de moeite om een online condoleance achter te laten op de pagina. Erg fijn om te lezen dat mijn man zo geliefd was, zelf bij mensen die ik zelf niet persoonlijk ken. De pagina geeft mij nog altijd steun op moeilijke momenten."}
      author={'Barbara H., nabestaande'}/>


    <section className={'bg-beige'}>
      <div className="container text-left">
        <p><strong>Aanmaken uitgebreide rouwpagina? Start met een account aanmaken</strong><br/>
          Maak snel en eenvoudig een account aan op Mensenlinq.nl en log in. Hier kun je een uitgebreide rouwpagina aanmaken, en de QR-code en URL genereren. Vanuit het account kun je de pagina op elk gewenst moment aanpassen en beheren, waardoor je volledige controle hebt over de inhoud. Lees hier wat <a href={relativeRoute('page', {'slug': 'verschil-standaard-rouwpagina-en-uitgebreide-rouwpagina'})}>het
            verschil is tussen een standaard en een uitgebreide rouwpagina</a>.</p>
        <p><strong>Account beheren</strong><br/>
          Na het aanmaken van de uitgebreide rouwpagina ligt het beheer in handen van degene die de pagina heeft aangemaakt. Mocht dit de uitvaartondernemer zijn, dan kan het beheer daarna eenvoudig worden overgedragen aan (één of meerdere) nabestaanden. De opmaak van de uitgebreide rouwpagina wordt automatisch gegenereerd en de pagina is eenvoudig te gebruiken.
        </p>
        <p><strong>Centrale plek voor online condoleances, informatie en herinneringen
        </strong><br/>Met de uitgebreide rouwpagina creëer je een centrale plek waar alles samenkomt. Dit kan het overzicht en de communicatie rondom de uitvaart vereenvoudigen. In plaats van meerdere berichten, condoleancemogelijkheden en rouwadvertenties via verschillende kanalen, kunnen alle betrokkenen op één plek terecht voor online condoleances, informatie en herinneringen.
        </p>
      </div>
    </section>

    <CallToAction
      imageBackground={imageBackgroundField}
      imageFloating={imageIpad}
      title={'Overlijden bekendmaken'}
      content={<>
        <p>Maak eenvoudig een uitgebreide rouwpagina aan, voeg informatie over de uitvaart toe, ontvang alle condoleances op één plek, en lees alle ontvangen steunbetuigingen op ieder moment terug.</p>
        <p>Vragen? Mail ons op <a href={'mailto:info@mensenlinq.nl'}>info@mensenlinq.nl</a>.</p>

        {onboarding ?
          <a className="button" href={relativeRoute('create')}>Overlijden bekendmaken</a> :
          <a className="button" href={"https://www.familieberichten.nl/home"} target={'_blank'}>Overlijden bekendmaken</a>
        }</>}
      />

  </Page>
}
